var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('interactive-text-designer',{attrs:{"settingStyles":_vm.interactiveTextController.contents.settings.styles,"leftPanelsTop":_vm.leftPanelsTop,"leftPanelsBottom":_vm.leftPanelsBottom,"pageId":_vm.pageId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }